import { fetchApi } from '@/config/axiosSetting';
import {
  GetHasOfflineShootingQueryParamsType,
  GetHasOfflineShootingQueryResponseType,
} from '@/modules/OfflineFiles/queries/getHasOfflineShooting/getHasOfflineShootingQuery.type';
import { offlineUserTypes } from '@/modules/OfflineFiles/types/OfflineFileTypes';

export const getHasOfflineShootingFunction = (
  params: GetHasOfflineShootingQueryParamsType,
): Promise<GetHasOfflineShootingQueryResponseType> => {
  let userType: offlineUserTypes;
  switch (params.userType) {
    case 'body':
    case 'initial':
      userType = 'insurer';
      break;
    case 'culprit':
      userType = 'culprit';
      break;
    case 'damaged':
      userType = 'damaged';
      break;
    default:
      userType = 'damaged';
      break;
  }

  return fetchApi.get(`offline_shooting/${params.id}/has-offline-shooting/`, {
    params: { damaged_id: params.damagedId, user_type: userType },
  });
};
